// #region Functions (6)
/**
 * Helper function to return an empty IObjectCollection.
 * @return {IObjectCollection<T>}
 */
export function createEmptyObjectCollection() {
  const result = {
    length: 0,
    data: []
  };
  return result;
}
/**
 * Helper function to return an object collection of type from an array of type.
 * @param {T[]} values
 * @return {IObjectCollection<T>}
 */
export function createObjectCollection(values) {
  const result = {
    length: values.length,
    data: values
  };
  return result;
}
/**
 * Helper function to return a JSON Collection from a string value.
 * Used when retrieving data from the database.
 * @param {any} databaseValue
 * @return {IObjectCollection<T> | undefined}
 */
export function returnJSONCollectionFromString(databaseValue) {
  if (databaseValue === undefined) {
    return createEmptyObjectCollection();
  }
  const databaseJSON = JSON.parse(databaseValue);
  if (!databaseJSON || typeof databaseJSON !== "object") {
    return createEmptyObjectCollection();
  }
  const result = createObjectCollection(databaseJSON);
  return result;
}
/**
 * Helper function to return a JSON Object from a string.
 * Used when getting data from the database.
 * @param {any} databaseValue
 * @return {T | undefined}
 */
export function returnJSONObjectFromString(databaseValue) {
  if (databaseValue === undefined || databaseValue === "") {
    return undefined;
  }
  return JSON.parse(databaseValue);
}
/**
 * Helper function to return a JSON string from an IObjectCollection.
 * Used when storing data in the database.
 * @param {IObjectCollection<T>} object
 * @return {string}
 */
export function returnJSONStringFromCollection(object) {
  if (object && object.data) {
    return `JSON '${JSON.stringify(object.data).replaceAll("'", "&#39;")}'`;
  } else {
    return "JSON '{}'";
  }
}
/**
 * Helper function to return a JSON string from an object.
 * Used when storing data in the database.
 * @param object
 * @returns
 */
export function returnJSONStringFromObject(object) {
  if (object) {
    return `JSON '${JSON.stringify(object).replaceAll("'", "&#39;")}'`;
  } else {
    return "JSON '{}'";
  }
}
// #endregion Functions (6)